import {
    GET_UOM_CONVERSION_LIST_PROGRESS, GET_UOM_CONVERSION_LIST_SUCCESS, GET_UOM_CONVERSION_LIST_FAILURE,
    ADD_UOM_CONVERSION_PROGRESS, ADD_UOM_CONVERSION_SUCCESS, ADD_UOM_CONVERSION_FAILURE,
    EDIT_DELETE_UOM_CONVERSION_PROGRESS, EDIT_DELETE_UOM_CONVERSION_SUCCESS, EDIT_DELETE_UOM_CONVERSION_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    uom_conversion: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const uom_conversion_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_UOM_CONVERSION_LIST_SUCCESS:
            return { ...state, uom_conversion: action.uom_conversion, loading: false };
        case GET_UOM_CONVERSION_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_UOM_CONVERSION_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_UOM_CONVERSION_PROGRESS:
            return { ...state, loading: true };
        case ADD_UOM_CONVERSION_SUCCESS:
            return { ...state, uom_conversion: [...state.uom_conversion, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_UOM_CONVERSION_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_UOM_CONVERSION_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_UOM_CONVERSION_SUCCESS:
            return {
                ...state,
                uom_conversion: state.uom_conversion.map((uom_conversion) =>
                    uom_conversion.id === action.payload.id ? action.payload : uom_conversion
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_UOM_CONVERSION_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default uom_conversion_reducer;